import React from 'react'
import LoginForm from '../overlays/LoginForm'
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

class Home extends React.Component {


    renderText = () => {
        const headerStyle = { 'fontSize': '32px', 'fontStyle': 'italic', 'marginBottom': '0px', 'fontWeight': '300' }
        const textArray = [(<><p style={headerStyle}>Collaboration</p><p>Share best practices across your team</p></>),
        (<><p style={headerStyle}>Intelligent Text</p><p style={{ 'marginBottom': '2px' }}>Meaningful commentary</p><p style={{ 'marginTop': '2px' }}>generated automatically</p></>),
        (<><p style={headerStyle}>Easy</p><p>One click refresh</p></>),
        (<><p style={headerStyle}>Speed</p><p>From data to actionable insights</p></>),
        ]
        return textArray[this.props.randNumber]
    }

    render() {
        return (
            <div>
                <div className="loginMainBox">
                    <div className="loginOpac">
                        <Container maxWidth="lg">
                            <Grid container spacing={3}>
                                <Grid item md={6} sm={6} xs={12}>
                                    <div className="loginLeft">
                                        <h2>Welcome To XP3 BI Cloud</h2>
                                        {this.renderText()}
                                    </div>
                                </Grid>
                                <Grid item md={6} sm={6} xs={12}>
                                    {(this.props.loggedIn) ? null : <LoginForm sendLogin={this.props.sendLogin} showPopup={this.props.showPopup} showMessage={this.props.showMessage} />}
                                </Grid>
                            </Grid>
                        </Container>
                    </div>
                </div>
            </div>
        )
    }
}

export default Home